export default "__VITE_ASSET__63d5ed3a__"